import { render, staticRenderFns } from "./AvailabilityReport.vue?vue&type=template&id=436f8f37"
import script from "./AvailabilityReport.vue?vue&type=script&lang=js"
export * from "./AvailabilityReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports